import React from 'react';
import Helmet from 'react-helmet';

const farmProjectURL = process.env.GATSBY_SITE_URL;

class HelmetBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.addScripts = this.addScripts.bind(this);
    this.addStyles = this.addStyles.bind(this);
    this.addLinks = this.addLinks.bind(this);
  }

  addScripts() {
    return [
      // add scripts as needed
      // example
      // {
      //   type: 'text/javascript',
      //   src: 'https://www.googletagmanager.com/gtag/js?id=AW-675894',
      //   async: true
      // }
    ];
  }

  addStyles() {
    return [];
  }

  addLinks() {
    return [
      {
        rel: 'canonical',
        href: 'https://thefarmproject.com'
      }
    ];
  }

  render() {
    let title;

    if (this.props.data) {
      title = this.props.data.title;
    } else if (this.props.title) {
      title = this.props.title;
    }

    let bodyClasses;

    if (this.props.bodyClasses) {
      bodyClasses = this.props.bodyClasses;
    }

    let meta = [];

    if (this.props.meta) {
      meta = this.props.meta;
    }

    let metadataInfo = {};

    if (this.props.data.metadata) {
      metadataInfo = this.props.data.metadata;

      meta.push({
        property: 'twitter:card',
        content: 'summary_large_image'
      });

      if (metadataInfo.title) {
        title = metadataInfo.title; // Overwrite page title
        meta.push(
          {
            property: 'og:title',
            content: metadataInfo.title
          },
          {
            property: 'twitter:title',
            content: metadataInfo.title
          }
        );
      }

      if (metadataInfo.description) {
        meta.push(
          {
            name: 'description',
            content: metadataInfo.description
          },
          {
            property: 'og:description',
            content: metadataInfo.description
          },
          {
            property: 'twitter:description',
            content: metadataInfo.description
          }
        );
      }

      if (metadataInfo.ogimage) {
        meta.push({
          property: 'og:image',
          content: `https:${metadataInfo.ogimage.file.url}?h=630&w=1200&fm=jpg&q=90`
        });
      }

      if (metadataInfo.twitterimage) {
        meta.push({
          property: 'twitter:image',
          content:
            metadataInfo.twitterimage.file.url + '?h=630&w=1200&fm=jpg&q=90'
        });
      }

      if (metadataInfo.twittercreator) {
        meta.push({
          property: 'twitter:creator',
          content: metadataInfo.twittercreator
        });
      }
    }

    if (this.props.pathname) {
      meta.push({
        property: 'og:url',
        content: `${farmProjectURL}${this.props.pathname}`
      });
    }

    if (metadataInfo.keywords) {
      meta.push({
        name: 'keywords',
        content: metadataInfo.keywords.join(',')
      });
    }

    const additionalAttributes = !bodyClasses
      ? {}
      : {
          bodyAttributes: {
            class: bodyClasses
          }
        };

    const styles = this.addStyles();
    const scripts = this.addScripts();
    const links = this.addLinks();

    return (
      <React.Fragment>
        <Helmet
          title={title}
          meta={meta}
          script={scripts}
          style={styles}
          links={links}
          {...additionalAttributes}
        />
      </React.Fragment>
    );
  }
}

export default HelmetBuilder;



// WEBPACK FOOTER //
// ./src/components/helmet-builder.js